module.exports = __webpack_public_path__ + "static/media/SALogoWhite.2e88f996.png";